module.exports = __webpack_public_path__ + "img/img_shouxinchongshenka2@2x.5708f1bc.png";